import { Box, IconButton, Text } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { deleteHomeworkRequest } from "../../../modules/admin-modules/homework/Actions";
import { openAddHomeworkModel } from "../../../modules/admin-modules/models/Actions";
import { brandPalette } from "../../../constants/brandPalette";

const C = {
  primary: brandPalette.primary,
  secondary: brandPalette.accentDark,
  border: brandPalette.stone,
};

const iconBtnProps = {
  variant: "ghost",
  border: "0",
  size: "sm",
  color: C.primary,
  _hover: { bg: "rgba(91, 13, 22, 0.08)", color: C.secondary },
};

const HomeworkTable = ({ setAdd, setSelectedData, searchTerm = "" }) => {
  const dispatch = useDispatch();
  const homeworks = useSelector((state) => state.homework.homeworks);
  const isLoading = useSelector((state) => state.homework.isLoading);

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(() => {
    const raw = Array.isArray(homeworks) ? homeworks : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return raw;
    return raw.filter((h) => {
      const title = h?.name?.toLowerCase() || "";
      const ch = h?.chapter_id?.name_ar?.toLowerCase() || "";
      const vid = h?.video_id?.title?.toLowerCase() || "";
      return title.includes(q) || ch.includes(q) || vid.includes(q);
    });
  }, [homeworks, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = list.find((h) => h.id === row?.id) ?? row;
    setSelectedData(plain);
  };

  const Data = list.map((data) => ({
    ...data,
    id: data?.id,
    title: data?.name,
    video: data?.video_id,
    video_id: data?.video_id?.id,
    chapter: data?.chapter_id,
    chapter_id: data?.chapter_id?.id,
    group: data?.groups?.map((group) => (
      <Text key={group?.id} as="span" display="block" fontSize="sm">
        {group?.name}
      </Text>
    )),
    edit: (
      <IconButton
        {...iconBtnProps}
        aria-label="Edit homework"
        fontSize="20px"
        icon={<RiFileEditLine />}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          setAdd(false);
          dispatch(openAddHomeworkModel());
        }}
      />
    ),
    delete: (
      <IconButton
        {...iconBtnProps}
        aria-label="Delete homework"
        fontSize="20px"
        icon={<RiDeleteBinLine color="#9b2c2c" />}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(deleteHomeworkRequest(data?.id));
        }}
      />
    ),
  }));

  const columns = [
    { Header: "Homework", accessor: "title" },
    { Header: "Chapter", accessor: "chapter_id.name_ar" },
    { Header: "Video", accessor: "video_id.title" },
    { Header: "Groups", accessor: "group" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Delete", accessor: "delete" },
  ];

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="var(--surface-raised)"
        border="1px solid"
        borderColor={C.border}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path="openModel"
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar
          noFilter
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: "var(--surface-muted)", color: "var(--text-primary)" }}
        />
      </Box>
    </Box>
  );
};

export default HomeworkTable;
